(function () {
    const scriptSrc = document.currentScript.getAttribute('data-section');
    const loop = document.currentScript.getAttribute('data-loop');
    const srcAutoplay = document.currentScript.getAttribute('data-autoplay');
    let autoplay = true;
    if (srcAutoplay == "false") {
        autoplay = false;
    } else {
        autoplay = parseInt(srcAutoplay);
    }

    const slideshow = () => {
        let current_section = window.document.querySelector('[id$="' + scriptSrc + '"]');
        if(!current_section.querySelector('.slideshow__carousel')) {
            return;
        }

        let flkty = new Flickity( '.slideshow__carousel', {
            cellAlign: 'left',
            contain: true,
            pageDots: true,
            wrapAround: loop,
            autoPlay: autoplay,
            prevNextButtons: false,
            arrowShape: {
                x0: 10,
                x1: 60, y1: 50,
                x2: 60, y2: 40,
                x3: 20
            },
        });

        window.onresize = function(event) { flkty.resize(); current_section.querySelector('.flickity-viewport').style.height = null; };

        // previous
        let previousButton = current_section.querySelector('.button--previous');
        previousButton.addEventListener( 'click', function() {
            flkty.previous();
        });
        // next
        let nextButton = current_section.querySelector('.button--next');
        nextButton.addEventListener( 'click', function() {
            flkty.next();
        });

        if (loop == "false") {
            flkty.on( 'settle', function( index ) {
                if(index === 0) {
                    previousButton.classList.add('hidden');
                    nextButton.classList.remove('hidden');
                } else if(index === flkty.slides.length - 1) {
                    nextButton.classList.add('hidden');
                    previousButton.classList.remove('hidden');
                } else if(index > 0 && index < flkty.slides.length - 1) {
                    nextButton.classList.remove('hidden');
                    previousButton.classList.remove('hidden');
                }
            });
        }
    };

    window.addEventListener('load', function () {
        slideshow();
    });
})();